export default __webpack_public_path__ + "static/media/odvz_color_blanco_tag.1e0fbf09.png";